import React from 'react';
import { IconProps } from '../types';
const MinecraftCherryChestBoat: React.FC<IconProps> = ({ size = 24, className, style }) => (
<svg width={size} height={size} className={className} style={style} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
<rect x="6" y="0" width="1" height="1" fill="rgba(55, 49, 39, 255)" />
<rect x="7" y="0" width="1" height="1" fill="rgba(55, 49, 39, 255)" />
<rect x="4" y="1" width="1" height="1" fill="rgba(55, 49, 39, 255)" />
<rect x="5" y="1" width="1" height="1" fill="rgba(55, 49, 39, 255)" />
<rect x="6" y="1" width="1" height="1" fill="rgba(127, 95, 34, 255)" />
<rect x="7" y="1" width="1" height="1" fill="rgba(127, 95, 34, 255)" />
<rect x="8" y="1" width="1" height="1" fill="rgba(55, 49, 39, 255)" />
<rect x="2" y="2" width="1" height="1" fill="rgba(55, 49, 39, 255)" />
<rect x="3" y="2" width="1" height="1" fill="rgba(55, 49, 39, 255)" />
<rect x="4" y="2" width="1" height="1" fill="rgba(127, 95, 34, 255)" />
<rect x="5" y="2" width="1" height="1" fill="rgba(143, 105, 29, 255)" />
<rect x="6" y="2" width="1" height="1" fill="rgba(143, 105, 29, 255)" />
<rect x="7" y="2" width="1" height="1" fill="rgba(167, 110, 31, 255)" />
<rect x="8" y="2" width="1" height="1" fill="rgba(167, 110, 31, 255)" />
<rect x="9" y="2" width="1" height="1" fill="rgba(55, 49, 39, 255)" />
<rect x="10" y="2" width="1" height="1" fill="rgba(205, 133, 128, 255)" />
<rect x="11" y="2" width="1" height="1" fill="rgba(205, 133, 128, 255)" />
<rect x="1" y="3" width="1" height="1" fill="rgba(55, 49, 39, 255)" />
<rect x="2" y="3" width="1" height="1" fill="rgba(143, 105, 29, 255)" />
<rect x="3" y="3" width="1" height="1" fill="rgba(167, 110, 31, 255)" />
<rect x="4" y="3" width="1" height="1" fill="rgba(171, 121, 45, 255)" />
<rect x="5" y="3" width="1" height="1" fill="rgba(167, 110, 31, 255)" />
<rect x="6" y="3" width="1" height="1" fill="rgba(143, 105, 29, 255)" />
<rect x="7" y="3" width="1" height="1" fill="rgba(171, 121, 45, 255)" />
<rect x="8" y="3" width="1" height="1" fill="rgba(167, 110, 31, 255)" />
<rect x="9" y="3" width="1" height="1" fill="rgba(143, 105, 29, 255)" />
<rect x="10" y="3" width="1" height="1" fill="rgba(55, 49, 39, 255)" />
<rect x="11" y="3" width="1" height="1" fill="rgba(221, 157, 151, 255)" />
<rect x="12" y="3" width="1" height="1" fill="rgba(205, 133, 128, 255)" />
<rect x="1" y="4" width="1" height="1" fill="rgba(55, 49, 39, 255)" />
<rect x="2" y="4" width="1" height="1" fill="rgba(40, 30, 11, 255)" />
<rect x="3" y="4" width="1" height="1" fill="rgba(167, 110, 31, 255)" />
<rect x="4" y="4" width="1" height="1" fill="rgba(171, 121, 45, 255)" />
<rect x="5" y="4" width="1" height="1" fill="rgba(171, 121, 45, 255)" />
<rect x="6" y="4" width="1" height="1" fill="rgba(167, 110, 31, 255)" />
<rect x="7" y="4" width="1" height="1" fill="rgba(171, 121, 45, 255)" />
<rect x="8" y="4" width="1" height="1" fill="rgba(171, 121, 45, 255)" />
<rect x="9" y="4" width="1" height="1" fill="rgba(167, 110, 31, 255)" />
<rect x="10" y="4" width="1" height="1" fill="rgba(143, 105, 29, 255)" />
<rect x="11" y="4" width="1" height="1" fill="rgba(55, 49, 39, 255)" />
<rect x="12" y="4" width="1" height="1" fill="rgba(221, 157, 151, 255)" />
<rect x="13" y="4" width="1" height="1" fill="rgba(205, 133, 128, 255)" />
<rect x="0" y="5" width="1" height="1" fill="rgba(221, 157, 151, 255)" />
<rect x="1" y="5" width="1" height="1" fill="rgba(40, 30, 11, 255)" />
<rect x="2" y="5" width="1" height="1" fill="rgba(104, 78, 30, 255)" />
<rect x="3" y="5" width="1" height="1" fill="rgba(40, 30, 11, 255)" />
<rect x="4" y="5" width="1" height="1" fill="rgba(167, 110, 31, 255)" />
<rect x="5" y="5" width="1" height="1" fill="rgba(143, 105, 29, 255)" />
<rect x="6" y="5" width="1" height="1" fill="rgba(143, 105, 29, 255)" />
<rect x="7" y="5" width="1" height="1" fill="rgba(205, 133, 128, 255)" />
<rect x="8" y="5" width="1" height="1" fill="rgba(205, 133, 128, 255)" />
<rect x="9" y="5" width="1" height="1" fill="rgba(143, 105, 29, 255)" />
<rect x="10" y="5" width="1" height="1" fill="rgba(40, 30, 11, 255)" />
<rect x="11" y="5" width="1" height="1" fill="rgba(40, 30, 11, 255)" />
<rect x="12" y="5" width="1" height="1" fill="rgba(231, 194, 187, 255)" />
<rect x="13" y="5" width="1" height="1" fill="rgba(205, 133, 128, 255)" />
<rect x="0" y="6" width="1" height="1" fill="rgba(205, 133, 128, 255)" />
<rect x="1" y="6" width="1" height="1" fill="rgba(40, 30, 11, 255)" />
<rect x="2" y="6" width="1" height="1" fill="rgba(71, 55, 37, 255)" />
<rect x="3" y="6" width="1" height="1" fill="rgba(104, 78, 30, 255)" />
<rect x="4" y="6" width="1" height="1" fill="rgba(40, 30, 11, 255)" />
<rect x="5" y="6" width="1" height="1" fill="rgba(143, 105, 29, 255)" />
<rect x="6" y="6" width="1" height="1" fill="rgba(176, 95, 99, 255)" />
<rect x="7" y="6" width="1" height="1" fill="rgba(241, 210, 204, 255)" />
<rect x="8" y="6" width="1" height="1" fill="rgba(205, 133, 128, 255)" />
<rect x="9" y="6" width="1" height="1" fill="rgba(40, 30, 11, 255)" />
<rect x="10" y="6" width="1" height="1" fill="rgba(104, 78, 30, 255)" />
<rect x="11" y="6" width="1" height="1" fill="rgba(40, 30, 11, 255)" />
<rect x="12" y="6" width="1" height="1" fill="rgba(231, 194, 187, 255)" />
<rect x="13" y="6" width="1" height="1" fill="rgba(176, 95, 99, 255)" />
<rect x="0" y="7" width="1" height="1" fill="rgba(176, 95, 99, 255)" />
<rect x="1" y="7" width="1" height="1" fill="rgba(241, 210, 204, 255)" />
<rect x="2" y="7" width="1" height="1" fill="rgba(66, 47, 11, 255)" />
<rect x="3" y="7" width="1" height="1" fill="rgba(71, 55, 37, 255)" />
<rect x="4" y="7" width="1" height="1" fill="rgba(104, 78, 30, 255)" />
<rect x="5" y="7" width="1" height="1" fill="rgba(40, 30, 11, 255)" />
<rect x="6" y="7" width="1" height="1" fill="rgba(176, 95, 99, 255)" />
<rect x="7" y="7" width="1" height="1" fill="rgba(176, 95, 99, 255)" />
<rect x="8" y="7" width="1" height="1" fill="rgba(231, 194, 187, 255)" />
<rect x="9" y="7" width="1" height="1" fill="rgba(205, 133, 128, 255)" />
<rect x="10" y="7" width="1" height="1" fill="rgba(104, 78, 30, 255)" />
<rect x="11" y="7" width="1" height="1" fill="rgba(40, 30, 11, 255)" />
<rect x="12" y="7" width="1" height="1" fill="rgba(231, 194, 187, 255)" />
<rect x="13" y="7" width="1" height="1" fill="rgba(176, 95, 99, 255)" />
<rect x="0" y="8" width="1" height="1" fill="rgba(176, 95, 99, 255)" />
<rect x="1" y="8" width="1" height="1" fill="rgba(231, 186, 180, 255)" />
<rect x="2" y="8" width="1" height="1" fill="rgba(241, 210, 204, 255)" />
<rect x="3" y="8" width="1" height="1" fill="rgba(66, 47, 11, 255)" />
<rect x="4" y="8" width="1" height="1" fill="rgba(71, 55, 37, 255)" />
<rect x="5" y="8" width="1" height="1" fill="rgba(104, 78, 30, 255)" />
<rect x="6" y="8" width="1" height="1" fill="rgba(40, 30, 11, 255)" />
<rect x="7" y="8" width="1" height="1" fill="rgba(104, 78, 30, 255)" />
<rect x="8" y="8" width="1" height="1" fill="rgba(176, 95, 99, 255)" />
<rect x="9" y="8" width="1" height="1" fill="rgba(231, 194, 187, 255)" />
<rect x="10" y="8" width="1" height="1" fill="rgba(205, 133, 128, 255)" />
<rect x="11" y="8" width="1" height="1" fill="rgba(231, 186, 180, 255)" />
<rect x="12" y="8" width="1" height="1" fill="rgba(205, 133, 128, 255)" />
<rect x="13" y="8" width="1" height="1" fill="rgba(142, 56, 68, 255)" />
<rect x="0" y="9" width="1" height="1" fill="rgba(176, 95, 99, 255)" />
<rect x="1" y="9" width="1" height="1" fill="rgba(231, 186, 180, 255)" />
<rect x="2" y="9" width="1" height="1" fill="rgba(231, 194, 187, 255)" />
<rect x="3" y="9" width="1" height="1" fill="rgba(241, 210, 204, 255)" />
<rect x="4" y="9" width="1" height="1" fill="rgba(66, 47, 11, 255)" />
<rect x="5" y="9" width="1" height="1" fill="rgba(71, 55, 37, 255)" />
<rect x="6" y="9" width="1" height="1" fill="rgba(40, 30, 11, 255)" />
<rect x="7" y="9" width="1" height="1" fill="rgba(71, 55, 37, 255)" />
<rect x="8" y="9" width="1" height="1" fill="rgba(66, 47, 11, 255)" />
<rect x="9" y="9" width="1" height="1" fill="rgba(176, 95, 99, 255)" />
<rect x="10" y="9" width="1" height="1" fill="rgba(231, 194, 187, 255)" />
<rect x="11" y="9" width="1" height="1" fill="rgba(205, 133, 128, 255)" />
<rect x="12" y="9" width="1" height="1" fill="rgba(231, 194, 187, 255)" />
<rect x="13" y="9" width="1" height="1" fill="rgba(205, 133, 128, 255)" />
<rect x="0" y="10" width="1" height="1" fill="rgba(176, 95, 99, 255)" />
<rect x="1" y="10" width="1" height="1" fill="rgba(231, 186, 180, 255)" />
<rect x="2" y="10" width="1" height="1" fill="rgba(231, 194, 187, 255)" />
<rect x="3" y="10" width="1" height="1" fill="rgba(231, 194, 187, 255)" />
<rect x="4" y="10" width="1" height="1" fill="rgba(241, 210, 204, 255)" />
<rect x="5" y="10" width="1" height="1" fill="rgba(66, 47, 11, 255)" />
<rect x="6" y="10" width="1" height="1" fill="rgba(40, 30, 11, 255)" />
<rect x="7" y="10" width="1" height="1" fill="rgba(241, 210, 204, 255)" />
<rect x="8" y="10" width="1" height="1" fill="rgba(231, 194, 187, 255)" />
<rect x="9" y="10" width="1" height="1" fill="rgba(221, 157, 151, 255)" />
<rect x="10" y="10" width="1" height="1" fill="rgba(176, 95, 99, 255)" />
<rect x="11" y="10" width="1" height="1" fill="rgba(225, 168, 161, 255)" />
<rect x="12" y="10" width="1" height="1" fill="rgba(230, 179, 173, 255)" />
<rect x="13" y="10" width="1" height="1" fill="rgba(231, 194, 187, 255)" />
<rect x="14" y="10" width="1" height="1" fill="rgba(205, 133, 128, 255)" />
<rect x="1" y="11" width="1" height="1" fill="rgba(142, 56, 68, 255)" />
<rect x="2" y="11" width="1" height="1" fill="rgba(231, 194, 187, 255)" />
<rect x="3" y="11" width="1" height="1" fill="rgba(231, 194, 187, 255)" />
<rect x="4" y="11" width="1" height="1" fill="rgba(231, 194, 187, 255)" />
<rect x="5" y="11" width="1" height="1" fill="rgba(241, 210, 204, 255)" />
<rect x="6" y="11" width="1" height="1" fill="rgba(241, 210, 204, 255)" />
<rect x="7" y="11" width="1" height="1" fill="rgba(231, 186, 180, 255)" />
<rect x="8" y="11" width="1" height="1" fill="rgba(231, 186, 180, 255)" />
<rect x="9" y="11" width="1" height="1" fill="rgba(176, 95, 99, 255)" />
<rect x="10" y="11" width="1" height="1" fill="rgba(231, 194, 187, 255)" />
<rect x="11" y="11" width="1" height="1" fill="rgba(230, 179, 173, 255)" />
<rect x="12" y="11" width="1" height="1" fill="rgba(225, 168, 161, 255)" />
<rect x="13" y="11" width="1" height="1" fill="rgba(230, 179, 173, 255)" />
<rect x="14" y="11" width="1" height="1" fill="rgba(231, 194, 187, 255)" />
<rect x="15" y="11" width="1" height="1" fill="rgba(205, 133, 128, 255)" />
<rect x="2" y="12" width="1" height="1" fill="rgba(142, 56, 68, 255)" />
<rect x="3" y="12" width="1" height="1" fill="rgba(231, 194, 187, 255)" />
<rect x="4" y="12" width="1" height="1" fill="rgba(231, 194, 187, 255)" />
<rect x="5" y="12" width="1" height="1" fill="rgba(241, 210, 204, 255)" />
<rect x="6" y="12" width="1" height="1" fill="rgba(231, 186, 180, 255)" />
<rect x="7" y="12" width="1" height="1" fill="rgba(231, 186, 180, 255)" />
<rect x="8" y="12" width="1" height="1" fill="rgba(225, 168, 161, 255)" />
<rect x="9" y="12" width="1" height="1" fill="rgba(142, 56, 68, 255)" />
<rect x="10" y="12" width="1" height="1" fill="rgba(176, 95, 99, 255)" />
<rect x="11" y="12" width="1" height="1" fill="rgba(231, 194, 187, 255)" />
<rect x="12" y="12" width="1" height="1" fill="rgba(230, 179, 173, 255)" />
<rect x="13" y="12" width="1" height="1" fill="rgba(225, 168, 161, 255)" />
<rect x="14" y="12" width="1" height="1" fill="rgba(231, 194, 187, 255)" />
<rect x="15" y="12" width="1" height="1" fill="rgba(205, 133, 128, 255)" />
<rect x="3" y="13" width="1" height="1" fill="rgba(142, 56, 68, 255)" />
<rect x="4" y="13" width="1" height="1" fill="rgba(231, 186, 180, 255)" />
<rect x="5" y="13" width="1" height="1" fill="rgba(241, 210, 204, 255)" />
<rect x="6" y="13" width="1" height="1" fill="rgba(230, 179, 173, 255)" />
<rect x="7" y="13" width="1" height="1" fill="rgba(142, 56, 68, 255)" />
<rect x="8" y="13" width="1" height="1" fill="rgba(142, 56, 68, 255)" />
<rect x="11" y="13" width="1" height="1" fill="rgba(176, 95, 99, 255)" />
<rect x="12" y="13" width="1" height="1" fill="rgba(231, 194, 187, 255)" />
<rect x="13" y="13" width="1" height="1" fill="rgba(231, 194, 187, 255)" />
<rect x="14" y="13" width="1" height="1" fill="rgba(225, 168, 161, 255)" />
<rect x="15" y="13" width="1" height="1" fill="rgba(205, 133, 128, 255)" />
<rect x="4" y="14" width="1" height="1" fill="rgba(142, 56, 68, 255)" />
<rect x="5" y="14" width="1" height="1" fill="rgba(142, 56, 68, 255)" />
<rect x="6" y="14" width="1" height="1" fill="rgba(142, 56, 68, 255)" />
<rect x="12" y="14" width="1" height="1" fill="rgba(176, 95, 99, 255)" />
<rect x="13" y="14" width="1" height="1" fill="rgba(176, 95, 99, 255)" />
<rect x="14" y="14" width="1" height="1" fill="rgba(176, 95, 99, 255)" />
<rect x="15" y="14" width="1" height="1" fill="rgba(176, 95, 99, 255)" />
</svg>);
export default MinecraftCherryChestBoat;